import React from 'react';

export const FollowGreenLayouts = { layout: React.lazy(() => import('./Layout/Layout')) };
